export enum ClientDetailsPersonRoleEnum {
  Debtor = 'Debtor',
  CoDebtor = 'CoDebtor',
}
